<template>
  <div class="fixed left-0 right-0 bb-min-h2pt5 bb-lh2pt5 center bb-ff3 bb-fs1pt13 bb-fc1 bb-transition2
  	bb-zindex2"
  	:class="[ success ? 'bb-bc6' : 'bb-bc7' ]">
  	{{ msg }}
  </div>
</template>

<script>
export default {
  name: 'miniNotification',
  props: ['msg', 'success']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/miniNotification.vue